<!-- Add edit product Grid -->
<div class="offcanvas-header">
  <div class="offcanvas-header-wrapper">
    <h5 class="mb-0 offcanvas-title" id="offcanvasRightLabel">
      Product Details
    </h5>
    <button
      #closeAccrBtn
      type="button"
      class="btn-close"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
    ></button>
  </div>
</div>
<div class="offcanvas-body p-0" style="height: calc(100vh - 80px)">
  <div class="canvas-body-wrapper">
    <div class="row mx-0 w-100" style="padding-inline: 4px 20px">
      <div class="col-md-7 cm-col">
        <div
          class="col-wrapper d-flex align-items-center"
          style="padding-top: 8px"
        >
          <div class="img-pre">
            <div
              class="img-pre-item"
              *ngFor="
                let imgItem of productRequest.productImages;
                let i = index
              "
            >
              <img class="w-100" [src]="imgItem.url" alt="Preview Image" />
            </div>
          </div>
          <div class="carousel-container">
            <div id="carouselExample" class="carousel slide">
              <div class="carousel-inner">
                <div
                  class="carousel-item"
                  [ngClass]="{ active: i === 0 }"
                  *ngFor="
                    let imgItem of productRequest.productImages;
                    let i = index
                  "
                >
                  <img
                    [src]="imgItem.url"
                    class="d-block w-100"
                    alt="Product Image"
                  />
                </div>
              </div>

              <button
                class="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExample"
                data-bs-slide="prev"
              >
                <span
                  class="carousel-control-prev-icon cc-ic"
                  aria-hidden="true"
                  *ngIf="productRequest.productImages.length > 1"
                  ><img src="../../../../../assets/Icons/Monotone_left.svg"
                /></span>
                <span class="visually-hidden"></span>
              </button>

              <button
                class="carousel-control-next"
                type="button"
                data-bs-target="#carouselExample"
                data-bs-slide="next"
              >
                <span
                  class="carousel-control-next-icon cc-ic"
                  aria-hidden="true"
                  *ngIf="productRequest.productImages.length > 1"
                  ><img src="../../../../../assets/Icons/Monotone_right.svg"
                /></span>
                <span class="visually-hidden"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-5 cm-col">
        <div class="col-wrapper" style="overflow: auto; scrollbar-width: thin">
          <div class="py-3">
            <h6 class="pb-3" style="font-weight: 600">
              {{ productRequest.name }}
            </h6>
            <p class="pb-2">
              {{ productRequest.description }}
            </p>
          </div>

          <div class="dt-grid">
            <div class="cm-grp gn-info">
              <h6 class="head-fd pt-1 pb-3">General Information</h6>
              <div class="dt-field">
                <h6>Condition</h6>
                <p>{{ productRequest.listerProduct.conditionName }}</p>
              </div>
              <div class="dt-field">
                <h6>SKU</h6>
                <p>{{ productRequest.sku || "-" }}</p>
              </div>
              <div class="dt-field">
                <h6>Department</h6>
                <p>
                  {{ productRequest.department?.name || "-" }}
                </p>
              </div>
              <div class="dt-field">
                <h6>Brand</h6>
                <p>{{ productRequest.brand?.name }}</p>
              </div>
              <div class="dt-field">
                <h6>Model</h6>
                <p>{{ productRequest.model || "-" }}</p>
              </div>
              <div class="dt-field">
                <h6>Serial Number</h6>
                <p>{{ productRequest.serialNumber || "-" }}</p>
              </div>
              <div class="dt-field">
                <h6>Category</h6>
                <p>
                  {{ productRequest.category?.name || "-" }}
                </p>
              </div>
              <div class="dt-field">
                <h6>Supplier</h6>
                <p>{{ productRequest.supplier?.name }}</p>
              </div>
              <div class="dt-field">
                <h6>Manufacturer</h6>
                <p>{{ productRequest.manufacturer || "-" }}</p>
              </div>
              <div class="dt-field">
                <h6>Warehouse location</h6>
                <p>
                  {{ productRequest.warehouseLocation?.name || "-" }}
                </p>
              </div>
              <div class="dt-field">
                <h6>Fragile</h6>
                <p>{{ productRequest.isFragile ? "Yes" : "No" }}</p>
              </div>
            </div>
            <div class="cm-gr attr-info pt-2">
              <h6 class="head-fd pt-1 pb-3">Physical Attributes</h6>
              <div class="dt-field">
                <h6>Height</h6>
                <p>
                  {{ productRequest.height || "-" }}
                  {{ productRequest.dimensionUnitName || "-" }}
                </p>
              </div>
              <div class="dt-field">
                <h6>Width</h6>
                <p>
                  {{ productRequest.width || "-" }}
                  {{ productRequest.dimensionUnitName || "-" }}
                </p>
              </div>
              <div class="dt-field">
                <h6>Length</h6>
                <p>
                  {{ productRequest.length || "-" }}
                  {{ productRequest.dimensionUnitName || "-" }}
                </p>
              </div>
              <div class="dt-field">
                <h6>Weight</h6>
                <p>
                  {{ productRequest.weight || "-" }}
                  {{ productRequest.weightUnitName || "-" }}
                </p>
              </div>
              <div class="dt-field">
                <h6>Shipment Box</h6>
                <p>
                  {{ productRequest.listerProduct.shipmentBox?.name || "-" }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
